<template>
    <div>
      <Header></Header>
      <div class="box">
      <div class="head-a">
        <img src="static/images/logo2.png" alt="">
      </div>
      <div class="content">
        <div>
          <h1>源代码说明</h1>
          <div style="font-size:18px;">
            <br>
            <Table border :columns="columns" :data="data"></Table>

            <h3>要求</h3>
            <div style="margin: 10px 0;">
              <List border>
                <ListItem >有代码后你需要处理：数组，循环，保存格式等内容，<br>
                  所以购买前提需要你有一些Python代码能力，方便自己修改代码里的内容。
                </ListItem>
                <ListItem >需要Python3环境
                </ListItem>
                <ListItem >需要Pandas、urllib3、requests、bs4、lxml模块
                </ListItem>
              </List>
            </div>
            <br>
            <h3>支付方式</h3>
            <h3>联系客服，沟通需求并确认费用</h3>
            <div style="text-align:center;">
              <img style="width:300px;height:300px;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/qrcode.png" alt="">
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
import Header from './header'

export default {
  components: {
    Header
  },

  data () {
    return {
      columns: [
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '说明',
          key: 'introduce'
        },
        {
          title: '价格',
          key: 'price'
        }
      ],
      data: [
        {
          name: '百度指数下载脚本Python源代码',
          introduce: '支持搜索指数和咨询指数下载',
          price: '100元'
        },
        {
          name: '源码使用远程指导',
          introduce: '通过远程连接帮调试指导',
          price: '100元'
        }
      ]
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@media (max-width: 768px){
  .box {
    width: 90vw !important;
  }
  .tx-box {
    margin: 0 !important;
  }
  .tb-box {
    margin: 40px 0 !important;
  }

}
a:hover {
  color: #177ff5;
}
// a:link{color: #177ff5;}
a:visited{color: #fff;}
.tao {
  color: #fff;
  background-color: #ec971f;
  border-color: #d58512;
  padding: 4px 8px;
  border-radius: 5px;
}
h3 {
  margin: 20px 0;
}
.box {
  margin: 60px auto;
  width: 60vw;
}
.head-a {
  background: #398dee;
  border-radius: 7px;
  padding: 20px;
}
.content {
  text-align: left;
  margin: 20px 0;
  padding: 20px;
}
.info {
  font-size: 18px;
  line-height: 34px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/intr_code.vue